import dayjs from "dayjs"
import { cloneDeep } from "lodash"
import store from "@/store/index.js"
import { getCustomVal } from '@/util/customData'
import { openapiGetapproval } from '@/port/clientSide/applicationRouting'
import route from '@/router/index.js';
import { numberSub, textSub } from '@/api/instrumentControl'
import { isStandardClass, getClassInfo } from "@/api/global.js";
import { findTreeNodeEnhanced, flattenTreeWithWhile } from '@/components/schoolInstrument/mixins/utils.js'
import qs from "qs";
/**
 * 控件选择值
 * */
export function control(type, key) {
  if (!type) return []
  const date = []
  const vacant = { name: '空值', val: 'vacant' }
  const noVacant = { name: '非空值', val: 'noVacant' }
  /*
  let like = { name: '包含', val: 'like' };
  let nolike = { name: '不包含', val: 'nolike' };
*/
  const gt = { name: '大于', val: 'gt' }
  const gte = { name: '大于等于', val: 'gte' }
  const lt = { name: '小于', val: 'lt' }
  const lte = { name: '小于等于', val: 'lte' }
  const eq = { name: '等于', val: 'eq' }
  const neq = { name: '不等于', val: 'neq' }
  const between = { name: '介于', val: 'between' }
  const inArr = { name: '包含', val: 'in' } // 包含数组
  const noin = { name: '不包含', val: 'noin' } // 不包含数组
  if (type === 'file' || type === 'image') {
    date.push(vacant, noVacant)
  }
  if (type === 'status') {
    date.push(inArr, noin)
  }
  if (type === 'number') {
    date.push(gt, gte, lt, lte, eq, neq, vacant, noVacant, between)
  }
  if (type === 'relation-user') {
    const caUser = { name: '等于当前用户', val: 'curuser' }
    const qtUser = { name: '等于任一成员', val: 'qtUser' }
    const nQtUser = { name: '不等于任一成员', val: 'nQtUser' }
    if (key) {
      date.push(caUser, qtUser, nQtUser, eq, neq, vacant, noVacant, inArr, noin)
    } else {
      date.push(qtUser, nQtUser, eq, neq, vacant, noVacant, inArr, noin)
    }
  }
  if (['text', 'textarea', 'radio', 'checkbox', 'richTextWid', 'new-rel-radio', 'relation-check', 'label'].indexOf(type) !== -1) {
    date.push(inArr, noin, vacant, noVacant)
  }
  if (type === 'date') {
    const thatDay = { name: '当天', val: 'thatDay' }
    const yesterday = { name: '昨天', val: 'yesterday' }
    const thisWeek = { name: '本周', val: 'thisWeek' }
    const lastWeek = { name: '上周', val: 'lastWeek' }
    const thisMonth = { name: '本月', val: 'thisMonth' }
    const lastMonth = { name: '上月', val: 'lastMonth' }
    const fixed = { name: '固定值', val: 'fixed' }
    date.push(thatDay, yesterday, thisWeek, lastWeek, thisMonth, lastMonth, fixed, between, vacant, noVacant, gte, lte)
  }
  if (type === 'roule' || type === 'organization') {
    date.push(eq, neq, vacant, noVacant, inArr, noin)
  }
  return date
}

/**
 * 新增联动关联选项值
 */
export function relevancyControl(type) {
  if (!type) return []
  const date = []

  const eq = { name: '等于', val: 'eq' }
  const inArr = { name: '包含', val: 'in' }
  const qtUser = { name: '等于任一成员', val: 'qtUser' }
  const gte = { name: '大于等于', val: 'gte' }
  const gt = { name: '大于', val: 'gt' }
  const lt = { name: '小于', val: 'lt' }
  const lte = { name: '小于等于', val: 'lte' }

  // - 单行输入框、多行输入框、单选、多选、副文本控件
  if (['text', 'textarea', 'radio', 'checkbox', 'richTextWid', 'new-rel-radio', 'relation-check'].indexOf(type) !== -1) {
    date.push(eq, inArr)
  }

  // - 联系人
  if (type === 'relation-user') {
    date.push(qtUser)
  }

  // - 时间
  if (type === 'date') {
    date.push(eq)
  }

  // - 数值
  if (type === 'number') {
    date.push(eq, gte, gt, lte, lt)
  }

  // - 状态
  if (type === 'status') {
    date.push(inArr)
  }

  return date
}

/**
 * 获取时间
 * */
export function getTime(type) {
  // 当天
  if (type.condition === 'thatDay') {
    return [0, 0]
  }
  // 昨天
  if (type.condition === 'yesterday') {
    return [-1, 0]
  }
  // 本周
  if (type.condition === 'thisWeek') {
    return [0, 7]
  }
  // 上周
  if (type.condition === 'lastWeek') {
    return [-7, 0]
  }
  // 本月
  if (type.condition === 'thisMonth') {
    return [0, 30]
  }
  // 上月
  if (type.condition === 'lastMonth') {
    return [-30, 0]
  }
  return type.conditionValue
}

/**
 * 数据筛选保存时关系转化
 * */
export function fileWhere(val) {
  if (!val) return
  // 空值
  if (val.condition === 'vacant') return { relation: 'isnull', value: '' }
  // 非空值
  if (val.condition === 'noVacant') return { relation: 'isnotnull', value: '' }
  // 等于任一成员
  if (val.condition === 'qtUser') return { relation: 'in', value: val.conditionValue }
  // 不等于任一成员
  if (val.condition === 'nQtUser') return { relation: 'noin', value: val.conditionValue }
  // 本周 or 上周 or 本月 or 上月 or 当天 or 昨天
  if (val.condition === 'thatDay') return { relation: 'between', value: [0, 0] }
  if (val.condition === 'thisWeek' ||
    val.condition === 'lastWeek' ||
    val.condition === 'thisMonth' ||
    val.condition === 'yesterday' ||
    val.condition === 'lastMonth') return { relation: 'between', value: val.conditionValue }
  // 固定值
  if (val.condition === 'fixed') return { relation: 'eq', value: val.conditionValue }
  if (val.type === 'relation-user' &&
    val.condition === 'eq' ||
    val.type === 'relation-user' &&
    val.condition === 'neq') return { relation: val.condition, value: val.conditionValue.length > 0 && Array.isArray(val.conditionValue) ? (val.conditionValue).join(',') : val.conditionValue }
  return { relation: val.condition, value: val.conditionValue }
  // return { relation: val.condition, value: val.condition === 'eq' ? Number(val.conditionValue) : val.conditionValue };
}

/**
 * 仪表盘表单关联场景数据筛选保存时关系转化
 * */
export function InstrufileWhere(val) {
  if (!val) return
  // 空值
  if (val.condition === 'vacant') return { relation: 'isnull', value: '' }
  // 非空值
  if (val.condition === 'noVacant') return { relation: 'isnotnull', value: '' }
  // 等于任一成员
  if (val.condition === 'qtUser') return { relation: 'in', value: val.conditionValue }
  // 不等于任一成员
  if (val.condition === 'nQtUser') return { relation: 'noin', value: val.conditionValue }
  // 本周 or 上周 or 本月 or 上月 or 当天 or 昨天
  if (val.condition === 'thatDay') return { relation: 'between', value: [0, 0] }
  if (val.condition === 'thisWeek' ||
    val.condition === 'lastWeek' ||
    val.condition === 'thisMonth' ||
    val.condition === 'yesterday' ||
    val.condition === 'lastMonth') return { relation: 'between', value: val.conditionValue }
  // 固定值
  if (val.condition === 'fixed') return { relation: 'eq', value: val.conditionValue }
  if (val.filedType != 'summary') {
    if (val.type === 'relation-user' &&
      val.condition === 'eq' ||
      val.type === 'relation-user' &&
      val.condition === 'neq') return { relation: val.condition, value: val.conditionValue.length > 0 ? (val.conditionValue).join(',') : val.conditionValue }
  } else {
    // - 汇总字段特殊处理（产品要求）
    if (val.SummaryType === 'relation-user' &&
      val.condition === 'eq' ||
      val.SummaryType === 'relation-user' &&
      val.condition === 'neq') return { relation: val.condition, value: val.conditionValue.length > 0 ? (val.conditionValue).join(',') : val.conditionValue }
  }

  return { relation: val.condition, value: val.conditionValue }
  // return { relation: val.condition, value: val.condition === 'eq' ? Number(val.conditionValue) : val.conditionValue };
}

/**
 * 横向连接，返回join 参数
 * */
export function retJoin(val) {
  const joins = []
  for (let i = 0; i < val.length; i++) {
    const date = val[i].map(item => {
      if (item.id && item.name) return item.id + '.' + item.name
      return null
    })
    if (date.indexOf(null) === -1) joins.push(date)
  }
  return joins
}

/**
 * 父路劲的两个组建不能是相同表单（横向连接）
 * */
export function xLinkNoLogin(list, path) {
  if (list.length <= 1) return false
  // 根据id 查找到一串名称用来比对
  const name = list.map(val => {
    const str = path.find(item => { return item.id === val })
    return str.approvalId ? str.approvalId : str.name
  })
  for (let i = 0; i < name.length; i++) {
    const item = JSON.parse(JSON.stringify(name.splice(i, 1)))
    if (item.indexOf(name[i]) !== -1) return true
  }
  return false
}
/**
 * 类型比对
 * */
export function typeContrast(val) {
  const date = {
    text: '文本类',
    label: '文本类',
    textarea: '文本类',
    radio: '文本类',
    checkbox: '文本类',
    image: '文本类',
    file: '文本类',
    richTextWid: '文本类',
    'relation-check': '文本类',
    status: '文本类',
    number: '数值类',
    date: '时间类',
    'relation-user': '用户ID'
  }
  if (date[val]) return date[val]
  return val
}

export function isTimeInRange(timeRange, targetTime) {
  if (!timeRange) return false;
  if (!Array.isArray(timeRange)) return timeRange
  if (!targetTime) return timeRange
  if (Array.isArray(targetTime)) targetTime = targetTime[0]
  // 解构数组，获取开始时间和结束时间
  const [startTime, endTime] = timeRange;

  // 判断目标时间是否在范围内
  let flag = targetTime >= startTime && targetTime <= endTime;
  if (flag) {
    return [targetTime, endTime];
  } else {
    return [startTime, targetTime];
  }
}

export const numConditionFn = () => {
  const gt = { name: '大于', val: 'gt' }
  const gte = { name: '大于等于', val: 'gte' }
  const lt = { name: '小于', val: 'lt' }
  const lte = { name: '小于等于', val: 'lte' }
  const eq = { name: '等于', val: 'eq' }
  const between = { name: '介于', val: 'between' }
  const list = []
  list.push(gt, gte, lt, lte, eq, between)
  return list
}

export const dateConditionFn = () => {
  const thatDay = { name: '当天', val: 'thatDay' }
  const yesterday = { name: '昨天', val: 'yesterday' }
  const thisWeek = { name: '本周', val: 'thisWeek' }
  const lastWeek = { name: '上周', val: 'lastWeek' }
  const thisMonth = { name: '本月', val: 'thisMonth' }
  const lastMonth = { name: '上月', val: 'lastMonth' }
  const between = { name: '介于', val: 'between' }
  const list = []
  list.push(thatDay, yesterday, thisWeek, lastWeek, thisMonth, lastMonth, between)
  return list
}

export const dealFixQuery = (data, customParams, customDeskId, screenRefValue = []) => {
  const obj = {
    ov: data.ov
  }
  data.linked && data.linked.forEach(item => {
    item.conditionValue = dealConditionValue(item, customParams, customDeskId)
    const screenValue = dealScreenValue(item, screenRefValue)

    if (Array.isArray(screenValue) && screenValue.length > 0) {
      if (Array.isArray(item.conditionValue)) {
        item.conditionValue.push(...screenValue)
      } else if (item.conditionValue) {
        item.conditionValue = [item.conditionValue, ...screenValue]
      } else {
        item.conditionValue = screenValue
      }
    }

    // // 测试说过滤值为空就不要传了
    // if (Array.isArray(item.conditionValue) && item.conditionValue.length === 0) return
    if (item.type === 'number' && item.conditionName === '介于') {
      if (typeof item.conditionValue === 'string') {
        item.conditionValue = item.conditionValue.split(',')
      }
      // 老谭说把这个min和max删了
      obj[item.submitName] = {
        op: item.conditionName,
        value: item.conditionValue,
        // min: item.conditionValue[0],
        // max: item.conditionValue[1]
      }
    } else if (item.type === 'date') {
      obj[item.submitName] = {
        op: item.conditionName,
        value: ''
      }
      obj[item.submitName].value = item.isCutom ? item.conditionValue : getConditionTime(item)
      if (obj[item.submitName].op === '等于') {
        obj[item.submitName].op = '固定值'
      }
    } else {
      if (item.type === 'checkbox' || item.type === 'radio') {
        const value = []
        if (Array.isArray(item.conditionValue)) {
          item.conditionValue.forEach(val => {
            if (val && val.split) {
              value.push(...val.split(','))
            }
          })
        }
        item.conditionValue = value
      } else if (item.type === 'relation-user') {
        obj[item.submitName] = {
          value: item.conditionValue || [],
          op: item.conditionName
        }
      }
      if (item.conditionValue && Array.isArray(item.conditionValue) && item.conditionValue.length === 0 && ['radio', 'checkbox', 'text', 'textarea'].includes(item.type)) {
        // TODO
      } else {
        if (item.conditionValue && item.conditionValue[0] === '' && item.conditionValue.length === 1) {
          // TODO
        } else {
          obj[item.submitName] = {
            value: item.conditionValue || [],
            op: item.conditionName
          }
        }
      }
    }
    if (item.noSearch && (!obj[item.submitName] || obj[item.submitName].length === 0)) {
      obj.noSearch = true
    }
  })
  return obj
}
export const dealConditionValue = (item, customParams, customDeskId) => {
  let conditionValue = item.conditionValue
  if (item.type === 'date' && item.timeSel) {
    conditionValue = item.timeSel
  }
  if (typeof conditionValue !== 'object' || conditionValue === null) return conditionValue
  let customData = []
  // 门户变量
  const doorCustomData = (customDeskId ? store.state.doorCustomDataObj[customDeskId] : store.state.doorCustomData) || []
  if (customParams && customParams.length > 0) {
    customData = [...customParams, ...doorCustomData]
  } else {
    customData = doorCustomData
  }
  if (!Array.isArray(conditionValue) && typeof conditionValue === 'object') {
    conditionValue = [conditionValue]
  }
  // 处理一下自定义的全局变量
  const resultArr = conditionValue.map(item => {
    let value = item
    if (item && typeof item === 'object' && item.datatype === 'custom') {
      let index = customData.findIndex(iter => `${iter.title}_${iter.type}` === `${item.title}_${item.type}`)
      if (index === -1) {
        // 如果title匹配不上再用名字匹配
        index = customData.findIndex(iter => iter.name === item.name)
      }
      if (index !== -1) {
        const data = customData[index]
        if (data.type === 'relation-user' && customData[index].value.length > 0) {
          value = {
            realname: customData[index].value[0].realname,
            userId: customData[index].value[0].userId
          }
        } else if (data.type === 'organization' && customData[index].value.length > 0) {
          value = {
            name: customData[index].value[0].name,
            organizationId: customData[index].value[0].organizationId
          }
        } else if (data.type === 'roule' && customData[index].value.length > 0) {
          value = {
            name: customData[index].value[0].name,
            roleId: customData[index].value[0].roleId
          }
        } else {
          value = customData[index].value
        }
      } else {
        value = ''
      }
    }
    return value
  }).filter(iter => {
    return Array.isArray(iter) ? iter.length > 0 : (iter || iter === 0)
  })
  return item.type === 'number' ? resultArr.join() : resultArr
}

export const dealScreenValue = (item, screenRefValue = []) => {
  let screenValue = []
  if (item.screenValue) {
    item.screenValue.forEach(screenItem => {
      const [i, level, field] = screenItem
      let fieldTitle, fieldType
      if (typeof field === 'string') {
        [fieldTitle, , fieldType] = field.split('_')
      } else if (field) {
        fieldTitle = field.title
        fieldType = field.type
      }
      const screenRef = screenRefValue.find(item => { return item.info.i === i })
      if (screenRef) {
        let value = []
        const levelType = screenRef.info.screenLevel && screenRef.info.screenLevel.levelType
        if (levelType === 'single') {
          // 单级筛选的取值
          value = screenRef.info.value
          const { optionMoreData } = screenRef
          if (value && value[0] === '全部') {
            if (Object.keys(optionMoreData).length > 0) {
              value = Object.keys(optionMoreData)
            }
          } else {
            const _value = []
            value.forEach(item => {
              let val = item
              if (optionMoreData && optionMoreData[val] && optionMoreData[val][fieldTitle] !== undefined) {
                val = optionMoreData[val][fieldTitle]
              }
              Array.isArray(val) ? _value.push(...val) : _value.push(val)
            })
            value = _value
          }
        } else if (levelType === 'multiple') {
          // 多级筛选的取值
          const { screenLevelData } = screenRef
          const levelData = screenLevelData[level] || []
          levelData.forEach(levelDataItem => {
            if (levelDataItem) {
              let itemData = levelDataItem.data[fieldTitle] || levelDataItem.label
              if (['relation-user', 'roule', 'organization'].includes(fieldType)) {
                  itemData = levelDataItem.fieldValue
                }
              if (Array.isArray(itemData)) {
                if (['relation-user', 'roule', 'organization'].includes(fieldType)) {
                  // 联系人、组织角色的处理
                  itemData.forEach(iter => {
                    const i = value.findIndex(item => {
                      return (item.userId && item.userId === iter.userId) ||
                        (item.roleId && item.roleId === iter.roleId) ||
                        (item.organizationId && item.organizationId === iter.organizationId)
                    })
                    if (i === -1) {
                      value.push(itemData)
                    }
                  })
                } else {
                  value.push(...itemData)
                  value = [...new Set(value)]
                }
              } else if (!value.includes(itemData)) {
                value.push(itemData)
              }
            }
          })
        }
        screenValue.push(...value)
      }
    })
  }
  return screenValue
}


export const getConditionTime = (item) => {
  let value = []
  if (item.conditionName === '当天') {
    value = [new Date(dayjs().startOf('date').$d).getTime(), new Date(dayjs().endOf('date').$d).getTime()]
  } else if (item.timeSel === 'current') {
    const date = new Date();
    date.setHours(8, 0, 0, 0);
    const timestamp = date.getTime();
    value = [timestamp]
  } else if (item.conditionName === '昨天') {
    const dateObj = dayjs().subtract(1, 'day')
    value = [new Date(`${dateObj.$y}-${dateObj.$M + 1}-${dateObj.$D} 00:00:00`).getTime(), new Date(`${dateObj.$y}-${dateObj.$M + 1}-${dateObj.$D} 23:59:59`).getTime()]
  } else if (item.conditionName === '本周') {
    value = [new Date(dayjs().startOf('week').$d).getTime(), new Date(dayjs().endOf('week').$d).getTime()]
  } else if (item.conditionName === '上周') {
    const prev = new Date().getDay()
    let sub = 7
    if (prev === 0) {
      sub += 7
    } else {
      sub = prev + sub - 1
    }
    const timeObj = dayjs().subtract(sub, 'day')
    const sunday = dayjs().subtract(sub - 6, 'day')
    const year = timeObj.$y
    const month = timeObj.$M + 1
    const day = timeObj.$D
    value = [new Date(`${year}-${month}-${day} 00:00:00`).getTime(), new Date(`${year}-${month}-${sunday.$D} 23:59:59`).getTime()]
  } else if (item.conditionName === '本月') {
    value = [new Date(dayjs().startOf('month').$d).getTime(), new Date(dayjs().endOf('month').$d).getTime()]
  } else if (item.conditionName === '上月') {
    const timeObj = dayjs().subtract(1, 'month')
    const year = timeObj.$y
    const month = timeObj.$M + 1
    value = [new Date(`${year}-${month}-01 00:00:00`).getTime(), new Date(`${year}-${month}-${new Date(year, month, 0).getDate()} 23:59:59`).getTime()]
  } else if (item.conditionName === '等于') {
    if (item.timeSel === 'current') {
      // value = [new Date(dayjs().startOf('date').$d).getTime(), new Date(dayjs().endOf('date').$d).getTime()]
      value = [new Date().getTime(), new Date(dayjs().endOf('date').$d).getTime()]
    } else {
      value = [new Date(dayjs(item.conditionValue).startOf('date').$d).getTime(), new Date(dayjs(item.conditionValue).endOf('date').$d).getTime()]
    }
  } else if (item.conditionName === '介于') {
    value = [new Date(`${item.conditionValue[0]} 00:00:00`).getTime(), new Date(`${item.conditionValue[1]} 23:59:59`).getTime()]
  } else {
    // 剩下的 都是 大于 大于等于 小于 小于等于 空值 非空值
    if (item.conditionName === '大于' || item.conditionName === '小于等于') {
      // value =  item.timeSel === 'current' ? new Date(dayjs().endOf('date').$d).getTime() : new Date(dayjs(item.conditionValue).endOf('date').$d).getTime()
      value = item.timeSel === 'current' ? new Date().getTime() : new Date(dayjs(item.conditionValue).endOf('date').$d).getTime()
    } else if (item.conditionName === '小于' || item.conditionName === '大于等于') {
      // value = item.timeSel === 'current' ? new Date(dayjs().startOf('date').$d).getTime() : new Date(dayjs(item.conditionValue).startOf('date').$d).getTime()
      value = item.timeSel === 'current' ? new Date().getTime() : new Date(dayjs(item.conditionValue).startOf('date').$d).getTime()
    } else {
      return []
    }
  }
  return value
}

export const dateList = ['date', 'timeof', 'dates']
export const defalutList = ['orders', 'status', 'text', 'textarea', 'radio', 'checkbox', 'richTextWid', 'relation-check', 'label']

export const isDate = (type) => {
  return dateList.indexOf(type) !== -1
}
export const isNum = (type) => {
  return type === 'number'
}
export const isNewRelRadio = (type) => {
  return type === 'new-rel-radio'
}
export const isUser = (type) => {
  return ['relation-user', 'appuser'].indexOf(type) !== -1
}
export const isDefault = (type) => {
  return defalutList.indexOf(type) !== -1
}

export const isOrganize = (type) => {
  return ['organization'].indexOf(type) !== -1
}
export const isRole = (type) => {
  return ['roule'].indexOf(type) !== -1
}

export const isConditionAppen = (data, row, isGateway = true, customData) => {
  if (!data) return true
  let count = 0
  const config = cloneDeep(data)
  isGateway
  const ov = config.ov
  const linked = config.linked || []
  const textArr = ['text', 'textarea', 'radio', 'richTextWid', 'new-rel-radio', 'relation-check', 'label', '单号']
  const isAppen = config.isAppen === 'appen'
  const schoolMsg = JSON.parse(localStorage.getItem('userMsg'))
  const userId = schoolMsg ? schoolMsg.userId : null
  const isEmpty = (item, val = '', val2 = '[]') => {
    // 需要兼容 联系人控件 因为联系人控件的值 可能会为空数组和空字符串
    return (item.condition === 'vacant' && (row[item.title] === val || row[item.title] === val2)) || (item.condition === 'noVacant' && (row[item.title] !== val || row[item.title] !== val2))
  }
  const arraysAreEqual = (arr1, arr2) => {
    // 如果数组长度不同，则它们不相等
    if (arr1.length !== arr2.length) {
      return false;
    }
    // 比较每个对象的属性值是否相同
    for (let i = 0; i < arr1.length; i++) {
      const obj1 = arr1[i];
      const obj2 = arr2[i];

      // 如果对象的属性数量不同，则它们不相等
      if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false;
      }

      // 比较每个属性值是否相同
      for (let key in obj1) {
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }
    }
    // 所有元素都相同，数组相等
    return true;
  }

  for (const item of linked) {
    if (item.title === '单号') item.type === '单号'
    let value
    if (item.datatype === 'custom') {
      value = getCustomVal(item, customData)
    } else {
      value = row[item.title] || row[item.name] || row[item.title + '_' + item.type]
    }
    const condition = item.condition
    let conditionValue = item.conditionValue || []
    if (Array.isArray(item.conditionValue)) {
      const resValue = []
      item.conditionValue.forEach(iter => {
        let val = iter
        if (typeof iter === 'object' && iter.datatype === 'custom') {
          val = getCustomVal(iter, customData)
          const arr = Array.isArray(val) ? val : [val]
          resValue.push(...arr)
        } else {
          resValue.push(val)
        }
      })
      conditionValue = resValue
    } else if (item.conditionValue && item.conditionValue.datatype === 'custom') {
      conditionValue = getCustomVal(item.conditionValue, customData)
    }
    if (Array.isArray(conditionValue)) {
      const _conditionValue = []
      conditionValue.forEach(val => {
        typeof val === 'string' ? _conditionValue.push(...val.split(',')) : _conditionValue.push(val)
      })
      conditionValue = _conditionValue
    } else {
      conditionValue = [conditionValue]
    }
    if (textArr.indexOf(item.type) !== -1) {
      // 单行输入框 多行输入框 等
      if (isEmpty(item)) {
        // 空值 和 非空值
        count++
      } else if (condition === 'in' && conditionValue.findIndex(val => { return val == value }) !== -1) {

        // 包含
        count++
      } else if (condition === 'noin' && conditionValue.findIndex(val => { return val == value }) === -1) {
        // 不包含
        count++
      }
    } else if (item.type === 'checkbox') {
      // 多选 value为数组
      let flag = false
      for (const ele of conditionValue) {
        flag = value.includes(ele)
        if (flag) break
      }
      if (isEmpty(item)) {
        // 空值 和 非空值
        count++
      } else if (condition === 'in' && flag) {
        // 包含
        count++
      } else if (condition === 'noin' && !flag) {
        // 不包含
        count++
      }
    } else if (item.type === 'date') {
      item.conditionValue = typeof item.conditionValue === 'object' ? conditionValue : item.conditionValue
      const resconditionValue = getConditionTime(item)
      const resValue = new Date(value).getTime()
      // else if (condition === 'bettewn' && Array.isArray(conditionValue)) {
      // 介于
      // }
      if (isEmpty(item)) {
        count++
      } else if ((condition === 'gte' && resValue >= resconditionValue) || (condition === 'gt' && resValue > resconditionValue)) {
        // 大于等于 大于
        count++
      } else if ((condition === 'lte' && resValue <= resconditionValue) || (condition === 'lt' && resValue < resconditionValue)) {
        // 小于等于 小于
        count++
      } else if ((condition === 'fixed' && resValue == resconditionValue)) {
        // 等于固定值
        count++
      } else {
        // 处理本月 本周 当天等情况 还有介于
        if (resValue > resconditionValue[0] && resValue <= resconditionValue[1]) count++
      }
    } else if (item.type === 'relation-user') {
      let resValue = value
      if (value && item.title !== '申请人') {
        resValue = typeof value === 'string' ? JSON.parse(value) : value
      } else if (item.title === '申请人') {
        resValue = [{ realname: value, userId: row.userId }]
      }
      if (isEmpty(item)) {
        count++
      } else if (condition === 'curuser') {
        const curIdx = resValue.findIndex(c => c.userId === userId)
        if (curIdx !== -1) {
          count++
        }
      } else if (condition === 'qtUser' || condition === 'nQtUser') {
        let flag = false
        for (const user of resValue) {
          const idx = conditionValue.findIndex(c => c.userId === user.userId)
          if (condition === 'qtUser' && idx !== -1) flag = true
          else if (condition === 'nQtUser' && idx === -1) flag = true
        }
        if (flag) count++
      } else if (condition === 'eq' && arraysAreEqual(resValue, conditionValue)) {
        count++
      } else if (condition === 'neq' && !arraysAreEqual(resValue, conditionValue)) {
        count++
      } else if (condition === 'in' || condition === 'noin') {
        const userIdList = conditionValue.map(item => { return item.userId })
        const idx = (resValue || []).findIndex(c => userIdList.includes(c.userId) )
        if (idx !== -1 && condition === 'in') count++
        else if (idx === -1 && condition === 'noin') count++
      }
    } else if (item.type === 'organization') {
      const idx = value.findIndex(c => conditionValue[0] && c.organizationId === conditionValue[0].organizationId)
      if (idx !== -1 && condition === 'in') count++
      else if (idx === -1 && condition === 'noin') count++
    } else if (item.type === 'roule') {
      const idx = value.findIndex(c => conditionValue[0] && c.roleId === conditionValue[0].roleId)
      if (idx !== -1 && condition === 'in') count++
      else if (idx === -1 && condition === 'noin') count++
    } else if (item.type === 'number') {
      const resValue = +value
      if (isEmpty(item)) {
        count++
      } else if ((condition === 'gte' && resValue >= +conditionValue) || (condition === 'gt' && resValue > +conditionValue)) {
        count++
      } else if ((condition === 'lte' && resValue <= +conditionValue) || (condition === 'lt' && resValue < +conditionValue)) {
        count++
      } else if ((condition === 'eq' && resValue === +conditionValue) || (condition === 'noeq' && resValue !== +conditionValue)) {
        count++
      } else if (condition === 'bettew' && resValue > +conditionValue[0] && resValue <= +conditionValue[0]) {
        count++
      }
    } else if (item.type === 'status') {
      let idx = -1
      if (item.title === '状态') {
        const resValue = row['状态']
        idx = conditionValue.findIndex(c => {
          return c === resValue
        })
      } else if (item.title === '归档状态') {
        const resValue = row.archive
        const obj = {
          0: '未归档',
          1: '已归档'
        }
        idx = conditionValue.findIndex(c => c === obj[resValue])
      }
      if (condition === 'in' && idx !== -1) {
        count++
      } else if (condition === 'noin' && idx === -1) {
        count++
      }
    }
    // 如果说满足一个条件就显示的话 直接返回就好了
    if (ov === 'or' && count >= 1) return isAppen
  }
  // 执行到这里  ov 一定是 and
  if (ov === 'and' && count === linked.length) return isAppen
  else return !isAppen
  // if (ov === 'and' && count === linked.length) return isAppen
}

export const getScreenValue = (screens = [], item) => {
  let val = ''
  let screen = screens.find(c => c.info.i === item.screenId)
  let type = item.screenType
  let isSetAll = false
  if (screen) {
    const isMultipleLevel = screen.info && screen.info.screenLevel && screen.info.screenLevel.levelType === 'multiple' ? true : false // 是否是多级
    // 多对多级的筛选方式
    const screenIdArr = item.screenIdArr || item.currentParam
    let screenValue = screen.info.value
    if (screenIdArr) {
      if (screenIdArr.length === 2 && screenIdArr[1] !== undefined) {
        let name = screenIdArr[1]
        let filed = `${name.split('_')[0]}_${name.split('_')[2]}`
        type = name.split('_')[2]
        if (screen.lableValueObj[filed]) {
          screenValue = screen.lableValueObj[filed]
        }
      } else if (screenIdArr.length === 3) {
        // 新版的筛选
        const [, level, field] = screenIdArr
        const [title, name, fieldType, dateof] = field.split('_')
        type = fieldType
        if (isMultipleLevel) {
          if (screen.$refs && screen.$refs.screenTreeRef) {
            const screenLevelData = screen.$refs.screenTreeRef.screenLevelData || {}
            screenValue = []
            const levelData = screenLevelData[level] || []
            levelData.forEach(levelDataItem => {
              if (levelDataItem) {
                let itemData = levelDataItem.data[title] || levelDataItem.data[name] || levelDataItem.label
                if (['relation-user', 'roule', 'organization'].includes(fieldType)) {
                  itemData = levelDataItem.fieldValue
                }
                if (Array.isArray(itemData)) {
                  if (['relation-user', 'roule', 'organization'].includes(fieldType)) {
                    // 联系人、组织角色的处理
                    itemData.forEach(iter => {
                      const i = screenValue.findIndex(item => {
                        return (item.userId && item.userId === iter.userId) ||
                          (item.roleId && item.roleId === iter.roleId) ||
                          (item.organizationId && item.organizationId === iter.organizationId)
                      })
                      if (i === -1) {
                        screenValue.push(iter)
                      }
                    })
                  } else {
                    screenValue.push(...itemData)
                    screenValue = [...new Set(screenValue)]
                  }
                } else if (!screenValue.includes(itemData)) {
                  screenValue.push(itemData)
                }
              }
            })
          }
        } else {
          const optionMoreData = screen.optionMoreData || {}
          screenValue = []
          let masterValue = screen.info.value
          if (screen.info.value[0] === '全部') {
            isSetAll = true
            masterValue = screen.optSearchList
          }
          masterValue.forEach(val => {
            let key = val
            if (typeof val === 'object') {
              key = `${val.realname || val.name}_${val.userId || val.organizationId || val.roleId}`
            }
            if (optionMoreData[key] && (optionMoreData[key][title] || optionMoreData[key][name])) {
              let value = (optionMoreData[key][title] || optionMoreData[key][name])
              value = Array.isArray(value) ? value : [value]
              screenValue.push(...value)
            } else {
              val = Array.isArray(val) ? val : [val]
              screenValue.push(...val)
            }
          })
          screenValue = Array.from(new Set(screenValue))
          if (fieldType === 'date' && dateof && screenValue.length === 2) {
            if (dateof === 'start') {
              screenValue = screenValue[0]
            } else if (dateof === 'end') {
              screenValue = screenValue[1]
            }
          }
        }
      }
    }
    if (isDefault(type)) {
      const value = screenValue
      // if (value.length !== 1) {
      //   Message.warning(`请选择需要使用的${screen.info.checkName}再进行下一步操作`)
      //   return
      // }
      // 多级不要走这边
      if (screen.info.checkAll && screen.info.isAppenAll !== false && !isSetAll && !(screen.lableValueObj && Object.keys(screen.lableValueObj).length > 0)) {
        // 选择了全部
        val = screen.optSearchList.join(',')
      } else {
        val = value.join(',')
      }
    } else if (isDate(type)) {
      val = screenValue
    } else if (isUser(type)) {
      if (isMultipleLevel) {
        val = screenValue
      } else {
        const condition = screen.conditionValue
        let organize = screen.info.organize
        if (screenValue && screenValue.length > 0) {
          organize = screenValue[0] === '全部' ? organize : screenValue
        }
        if (condition === 'curuser') {
          const schoolMsg = JSON.parse(localStorage.getItem('userMsg'))
          val = [{
            userId: schoolMsg.userId,
            realname: schoolMsg.realname
          }]
        } else if (condition === 'in' || condition === 'eq') {
          val = organize
        } else if (condition === 'vacant') {
          val = '[]'
        } else {
          if (JSON.stringify(organize) === "['']") {
            val = '[]'
          } else {
            val = organize
          }
        }
      }
    } else if (isOrganize(type)) {
      const condition = screen.conditionValue
      let li = screen.info.organizationList || []
      if (screenValue && screenValue.length > 0) {
        li = screenValue[0] === '全部' ? li : screenValue
      }

      if (condition === 'in' || condition === 'eq') {
        val = li
      } else if (condition === 'vacant') {
        val = '[]'
      } else {
        if (JSON.stringify(li) === "['']") {
          val = '[]'
        } else {
          val = li
        }
      }
    } else if (isRole(type)) {
      const condition = screen.conditionValue
      let li = screen.info.roleList
      if (screenValue && screenValue.length > 0) {
        li = screenValue[0] === '全部' ? li : screenValue
      }
      if (condition === 'in' || condition === 'eq') {
        val = li
      } else if (condition === 'vacant') {
        val = '[]'
      } else {
        if (JSON.stringify(li) === "['']") {
          val = '[]'
        } else {
          val = li
        }
      }
    } else if (isNum(type)) {
      const value = screenValue
      val = value
    } else if (isNewRelRadio(type)) {
      val = screen.newRelRadioCover
    }
  }
  return val
}

export const getParamsValue = (item, _customData) => {
  const paramsName = item.paramsName
  let paramsFiled
  if (item.filedList) {
    paramsFiled = item.filedList.find(iten => { return iten.datatype === 'custom' && paramsName === iten.name })
  }
  const customData = _customData.length > 0 ? _customData : store.state.doorCustomData || []
  // 尽量用title去做匹配
  const index = customData.findIndex(item => paramsFiled ? paramsFiled.title === item.title : item.name === paramsName)
  let val = ''
  if (index !== -1) {
    val = customData[index].value
  }
  return val
}

// 新增传参
export const getAddCoverval = (opt) => {
  let obj = {}
  const { newlyAddCustomed = [], newlyAdded = [], screens = [], currentOrg = {}, isDashboard = false, customData = [], orgList = [] } = opt
  if (newlyAddCustomed && Array.isArray(newlyAddCustomed)) {
    newlyAddCustomed.forEach(item => {
      obj[item.filedName] = item.filedValue
    })
  }
  if (newlyAdded && Array.isArray(newlyAdded)) {
    newlyAdded.forEach(item => {
      let val = ''
      const curTitle = item.filedName.split('_')[0]
      const curItem = item.filedList.find(c => c.title === curTitle)
      if (item.orgName === 'screen' && screens && screens.length !== 0) {
        val = getScreenValue(screens, item)
      } else if (item.orgName === 'params' && item.paramsName) {
        val = getParamsValue(item, customData)
      } else {
        if (curItem && curItem.type === 'organization' && item.orgName === 'id') {
          if (orgList.length === 0) {
            if (currentOrg.id) {
              val = [{
                organizationId: currentOrg.id,
                name: currentOrg.name,
                looktype: currentOrg.looktype,
                type: currentOrg.type,
              }]
            } else {
              val = []
            }
          } else {
            const org = findTreeNodeEnhanced({ organizationId: null, children: orgList }, currentOrg.id, { idKey: 'organizationId' })
            if (org) {
              const li = org.children
              if (li && li.length > 0) {
                val = flattenTreeWithWhile(org)
              } else {
                val = [org]
              }
            } else {
              if (currentOrg.id) {
                val = [{
                  organizationId: currentOrg.id,
                  name: currentOrg.name,
                  looktype: currentOrg.looktype || 0,
                  type: currentOrg.type,
                }]
              } else {
                val = []
              }
            }
          }
        } else {
          val = currentOrg[item.orgName]
        }
      }
      let filedName = item.filedName
      if (isDashboard) {
        const title = item.filedName.split('_')[0]
        if (val || val === 0) {
          // 陆洋说如果是空数据就不用传参
          obj[title] = val
        }
      } else {
        if (filedName && filedName.search('checkbox') !== -1 && !Array.isArray(val)) {
          val = [val]
        }
        if (curItem) {
          const fatherType = curItem.fatherType || ''
          const isReady = fatherType.includes('ready-widget')
          const isNewRelRadio = fatherType.includes('new-rel-radio')
          if (isReady) {
            // 说明是预约控件
            const fFiledName = fatherType.split('.')[0]
            const fValue = { [filedName]: val }
            if (obj[fFiledName]) {
              obj[fFiledName] = [
                {
                  ...obj[fFiledName][0],
                  ...fValue
                }
              ]
            } else {
              obj[fFiledName] = [fValue]
            }
          } else if (isNewRelRadio) {
            obj = {
              ...obj,
              ...val
            }
          } else {
            obj[filedName] = val
          }
        } else {
          obj[filedName] = val
        }
      }
    })
  }
  return obj
}
// 页面变量的传参
export const getParamsLists = (opt) => {
  const { paramsList, customData, currentOrg, screen, tableData = [] } = opt
  const paramsLists = []
  paramsList.forEach(iter => {
    const obj = {
      name: iter.otherParam,
      value: ''
    }
    if (iter.type === 'customize') {
      obj.value = iter.currentParam
    } else {
      // 获取的是表单的参数
      if (iter.orgName === 'id' || iter.orgName === 'name') {
        // 本级组织id、本级组织名称
        obj.value = currentOrg[iter.orgName]
      } else if (iter.orgName === 'screen') {
        // 本级组织筛选值
        obj.value = getScreenValue(screen, iter)
      } else {
        // 变量
        const index = customData.findIndex(citer => citer.name === iter.currentParam)
        if (index !== -1) {
          obj.value = customData[index].value
          if (customData[index].type === 'relation-user' && Array.isArray(obj.value)) {
            obj.value = obj.value.map(item => {
              delete item.pinyin
              return item
            })
          }
        } else {
          // 选择表格数据的情况
          const strArr = iter.currentParam.split('-')
          if (strArr.length >= 2) {
            const title = strArr[0]
            const name = strArr[1]
            const type = strArr[2]
            obj.value = tableData[title] || tableData[name] || tableData[`${title}_${type}`] || ''
          }
        }
      }
    }
    paramsLists.push(obj)
  })
  return paramsLists
}
const week = ['日', '一', '二', '三', '四', '五', '六']

export function timeSub(time, format) {
  if (!format || !time) return time
  const date = new Date(time)
  const Y = date.getFullYear()
  const M = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  const D = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
  const W = date.getDay()

  const h = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
  const m = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
  const s = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()
  // 如果是默认的，直接放后台给什么就是什么
  if (format === 'yyyy-MM-dd HH:mm:ss') return time
  if (format === 'yyyy-MM-dd') return Y + '-' + M + '-' + D
  if (format === 'yyyy-MM-dd HH:mm') return Y + '-' + M + '-' + D + ' ' + h + ':' + m
  if (format === 'yyyy-MM-dd-week') return Y + '-' + M + '-' + D + ` 星期${week[W]}`
  if (format === 'yyyy-MM-dd-weeks') return Y + '-' + M + '-' + D + ` ${getYearWeek(Y, M, D)}周`
  if (format === 'yyyy') return Y + '年'
  if (format === 'yyyy-MM') return Y + '年' + M + '月'
  if (format === 'yyyy-WW') return Y + '年' + getYearWeek(Y, M, D) + '周'
  if (format === 'HH:mm:ss') return h + '时' + m + '分' + s + '秒'
}

export function getYearWeek(a, b, c) {
  var date1 = new Date(a, parseInt(b) - 1, c); var date2 = new Date(a, 0, 1)
  var d = Math.round((date1.valueOf() - date2.valueOf()) / 86400000)
  return Math.ceil((d + ((date2.getDay() + 1) - 1)) / 7)
}


export const getUserParam = (opt) => {
  const { data, id, info } = opt
  let param = {}
  data.bindinf = info
  param.onlyUser = true; //只选用户
  param.isLook = data.lookRMSIsUser; //查看范围。1:本部门不含子部门,2:本部门及其子部门,3:全部部门,4:自定义,
  param.isGroup = data.isGroup; // 是否显示自定义分组
  // let isMany = data.singleIsUser; //是否可以多选。为1可以多选
  param.approvalId = id; // 应用id
  param.grouping = 0
  param.radio_ = data.singleIsUser ? false : true;
  param.isShowID = data.isShowID; // 是否显示用户身份证
  if (data.lookRMSIsUser == "4") {
    if (data.lookCustomArr.length > 0) {
      param.lookCustomArr = JSON.parse(data.lookCustomArr); //自定义
    }
  } else if (data.lookRMSIsUser == "5") {
    param.isorgs = true;
  } else if (data.lookRMSIsUser == "1" || data.lookRMSIsUser == "2" || data.lookRMSIsOrg == "1") {
    param.JsonDataOrg = { organizationId: 1, pid: -1 };
    param.leafOrg = data.lookRMSIsUser == "1";
  }
  if (data.bindinf) {
    if (data.bindinf.length != 0) {
      param.bindinf = []; //已选用户
      if (data.type == 'organization') {
        data.bindinf.forEach(el => {
          var obj = {
            name: el.name,
            organizationId: el.organizationId,
            looktype: el.looktype || 0,
            type: el.type
          };
          param.bindinf.push(obj);
        });
        param.checkedFlowArr = param.bindinf; //选中
      }
      // 角色控件，传name、roleId
      else if (data.type == 'roule') {
        data.bindinf.forEach(el => {
          var obj = {
            name: el.name,
            roleId: el.roleId
          };
          param.bindinf.push(obj);
        });
        param.checkedRoleArr = param.bindinf; //选中
      }
      else {
        data.bindinf.forEach(el => {
          var obj = {
            realname: el.realname,
            userId: el.userId,
            orgname: el.orgname
          };
          param.bindinf.push(obj);
        });
        param.checkedUserArr = param.bindinf; //选中
      }
    }
  }
  if (data.lookRMSIsUserRole) {
    param.isLookRole = data.lookRMSIsUserRole;
    //自定义
    if (data.lookRMSIsUserRole == 1) {
      //所在角色
      param.JsonDataRole = { selfrole: 1, pid: -1 };
      param.leafRole = true;
    } else if (data.lookRMSIsUserRole == 3) {
      //如果没有选择自定义角色默认为无
      param.lookCustomArrRole = data.lookCustomArrRole || [];
    } else if (data.lookRMSIsUserRole == 4) {
      param.isrole = true;
    }
  } else {
    param.isrole = true;
  }
  if (data.type == 'organization') {
    param.isuser = 'true'
    param.isrole = 'true'
    param.onlyUser = false //只选用户
    // 组织设置,只能选择一个组织，最大可选数改成1
    if (data.singleIsOrg === 0) param.maxCount = 1
    else param.maxCount = data.maxCount
    // 组织查看范围选择全部组织的时候，传入可选择标签值
    if (data.lookRMSIsOrg === 2) param.orgEqual = true
    else if (data.lookRMSIsOrg === 3) param.orgLabel = data.orgLabel
    // 自定义，传入后台已选择的组织，不调接口
    else if (data.lookRMSIsOrg === 4) {
      param.lookCustomArr = data.lookCustomArr
    }
  }
  param.isapiurl = "/openapi";
  if (data.maxCount) {
    param.maxCount = data.maxCount
  }
  if (data.type == 'roule') {
    param.isuser = true
    param.isorgs = true
    param.onlyUser = false //只选用户
    // 组织设置,只能选择一个组织，最大可选数改成1
    if (data.singleIsRoule === 0) param.maxCount = 1
    else param.maxCount = data.maxCount
  }
  return param
}

export const getLastTime = (time) => {
  time.setHours(23);
  time.setMinutes(59);
  time.setSeconds(59);
  time.setMilliseconds(999)
  // 获取当前日期的时间戳（单位：毫秒）
  let timestamp = time.getTime();
  return timestamp
}

export const getStartTime = (time) => {
  time.setHours(0);
  time.setMinutes(0);
  time.setSeconds(0);
  time.setMilliseconds(0)
  // 获取当前日期的时间戳（单位：毫秒）
  let timestamp = time.getTime();
  return timestamp
}

export const isAdaption = (li = []) => {
  const val = li.find(c => c.isAdaption)
  return Boolean(val)
}

export const getInsideScreenParam = (opt = {}) => {
  let obs = {}
  const { screens, currentOrg, screenLinked, customData, orgList = [] } = opt
  const newlyAdded = screenLinked.map(item => {
    const { type, orgName, FormList, screenId, screenIdArr } = item
    const typeI = FormList.findIndex(its => {
      return its.name === item.conditionValue
    })
    const typeObj = FormList[typeI]
    let filedName = ''
    if (item.conditionValue.includes('_custom') && typeI === -1) {
      filedName = item.conditionValue
    } else {
      filedName = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
    }
    return {
      filedName,
      filedList: FormList,
      orgName,
      screenId,
      screenType: type,
      screenIdArr,
    }
  })
  obs = getAddCoverval({ newlyAdded, newlyAddCustomed: [], screens, currentOrg, customData, orgList })
  return obs
}

export const getTMbulkImportParam = async (approvalId, bulkImportMutat, importSet = {}, allInCustomInfo) => {

  // allInCustomInfo 按钮的自定义导入配置
  const obj = {
    dialogUrl: `/clientSide/workbench/TMbulkImport?approvalId=${approvalId}&bulkImportMutat=${bulkImportMutat}`,
    isVisible: true,
    dialogName: '数据导入',
    openType: 'rightdia',
    diaSize: 'custom',
    customSize: 100
  }
  if (allInCustomInfo) {
    if (allInCustomInfo.valueSearchList && allInCustomInfo.valueSearchList.length > 0) {
      allInCustomInfo.valueSearchList = JSON.stringify(allInCustomInfo.valueSearchList)
    }
    obj.dialogUrl += `&${qs.stringify(allInCustomInfo)}`
  }
  // 如果配置没传就去获取一下
  if (JSON.stringify(importSet) === '{}') {
    const { code, data } = await openapiGetapproval({ approvalId: approvalId })
    if (code === 0 && data.baseset) {
      const baseset = JSON.parse(data.baseset)
      if (baseset.importSet) importSet = baseset.importSet
    }
  }
  if (JSON.stringify(importSet) !== '{}') {
    obj.diaSize = importSet.diaSize
    obj.openType = importSet.openType
    if (importSet.diaSize === 'custom') {
      if (importSet.openType === 'rightdia') {
        obj.customSize = 100
      } else if (importSet.openType === 'dialog') {
        obj.dialogHeight = importSet.diaheight
        obj.dialogWidth = importSet.diaWidth
      }
    }
  }
  if (obj.openType === 'old') {
    let query = { approvalId, bulkImportMutat, isPage: true }
    if (allInCustomInfo) {
      query = { ...query, ...allInCustomInfo }
    }
    route.push({ path: '/clientSide/workbench/TMbulkImport', query })
  } else if (obj.openType === 'new') {
    obj.dialogUr += '&isPage=true'
    window.open(obj.dialogUrl, '_blank');
  } else {
    return obj
  }
}


export const getScreenRectInfo = (comps, type = 'customW') => {
  const w = {
    customW: 240,
    customH: 35
  }
  if (comps.isAdaption) return 'initail'
  if (comps.type === 'screen') return `${comps[type] ? comps[type] : w[type]}px`
  else if ((comps.type === 'button' || comps.type === 'button-container') && type === 'customH') return '40px'
  else return 'auto'
}

export const getDateValue = (val, filed, row) => {
  let str = val
  if (!filed.filedInfo) return str
  if (filed.title === '提交时间') {
    // 老谭说  提交时间取单号
    val = Number(row['单号'])
  }
  const date = filed.filedInfo.date
  str = timeSub(val, date)
  return str
}

export const getNumValue = (val, filed) => {
  let str = val
  if (!filed.filedInfo) return str
  const { numFormat, configNumber, setNum } = filed.filedInfo
  if (!setNum) return str
  if (!numFormat) return str
  if (!configNumber) return str
  str = numberSub(val, configNumber.decimal)
  if (numFormat === 'currency' && configNumber.currency === '万元') {
    str = typeof str === 'number' ? str.toString() : str
    const strArr = str.split('.')
    let decimal = configNumber.decimal + 4
    // 是否要保留小数点
    const isDecimal = strArr.length > 2 && strArr[1].length > decimal ? true : false
    str = isDecimal ? (Number(str) / 10000).toFixed(decimal) : Number(str) / 10000
    if (configNumber.separator) {
      str = numFormatFun(val)
    }
    return str + '万元'
  }
  if (numFormat === 'percentage') {
    str = (Number(str) * 100).toFixed(configNumber.decimal)
    str += '%'
    return str
  }
  str = Number(str).toFixed(configNumber.decimal)
  if (configNumber.separator) {
    str = numFormatFun(val)
  }
  if (numFormat === 'currency' || numFormat === 'accounting') {
    str = configNumber.currency + str
  }

  if (numFormat === 'number' && configNumber.customSymbols) {
    str += configNumber.customSymbols
  }
  return str
}

export const numFormatFun = (num) => {
  const res = num.toString().replace(/\d+/, function (n) { // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + ','
    })
  })
  return res
}

export const getTextValue = (val, filed) => {
  let str = val
  if (!filed.filedInfo) return str
  const { encryption, displayConversion } = filed.filedInfo
  if (encryption) {
    str = textSub(val, 6)
  }
  if (displayConversion && isStandardClass(val, 'class')) {
    str = getClassInfo(val, displayConversion)
  }
  return str
}

export const performTakss = (tasts = []) => {
  // 如果tasts数组为空，则直接返回
  if (tasts.length === 0) return
  // 定义一个变量idx，初始值为0
  let idx = 0
  // 定义一个函数_run，用于执行tasts数组中的任务
  const _run = () => {
    // 使用requestIdleCallback函数，在浏览器空闲时执行任务
    requestIdleCallback((idle) => {
      // 当idx小于tasts数组的长度且浏览器空闲时间大于0时，执行任务
      while (idx < tasts.length && idle.timeRemaining() > 0) {
        // 执行tasts数组中的任务
        tasts[idx++]()
      }
      // 如果idx小于tasts数组的长度，则继续执行_run函数
      if (idx < tasts.length) _run()
    })
  }
  // 执行_run函数
  _run()
}


export const getOtherLinked = (opt = {}) => {
  const { linked, currentOrg, currentUser, orgList = [] } = opt
  const obs = {}
  if (linked.length === 0) return obs
  for (const ele of linked) {
    const formlist = ele.FormList
    const conditionValue = ele.conditionValue
    const form = formlist.find(f => f.name === ele.conditionValue.split('_')[0])
    let val = ''
    if (ele.orgName === 'orgId') {
      // 组织id
      if (form.type === 'organization') {
        if (orgList.length === 0) {
          if (currentOrg.id) {
            val = [{
              organizationId: currentOrg.id,
              name: currentOrg.name,
              looktype: currentOrg.looktype || 0,
              type: currentOrg.type,
            }]
          } else {
            val = []
          }
        } else {
          const org = findTreeNodeEnhanced({ organizationId: null, children: orgList }, currentOrg.id, { idKey: 'organizationId' })
          if (org) {
            const li = org.children
            if (li && li.length > 0) {
              val = flattenTreeWithWhile(org)
            } else {
              val = [org]
            }
          } else {
            if (currentOrg.id) {
              val = [{
                organizationId: currentOrg.id,
                name: currentOrg.name,
                looktype: currentOrg.looktype || 0,
                type: currentOrg.type,
              }]
            } else {
              val = []
            }
          }
        }
      } else {
        if (orgList.length === 0) {
          val = currentOrg.id
        } else {
          const org = findTreeNodeEnhanced({ organizationId: null, children: orgList }, currentOrg.id, { idKey: 'organizationId' })
          if (org) {
            const li = org.children
            if (li && li.length > 0) {
              const lis = flattenTreeWithWhile(org)
              val = lis.map(f => f.organizationId).join(',')
            } else {
              val = org.organizationId
            }
          } else {
            val = currentOrg.id
          }
        }
      }
    } else if (ele.orgName === 'userId') {
      val = currentUser.userId
    } else if (ele.orgName === 'orgName') {
      val = currentOrg.name
    }
    if (conditionValue && conditionValue.search('_custom') !== -1) {
      obs[`${conditionValue.split('_')[0]}_custom`] = val.map(item => {
        if (item.organizationId) {
          return {
            organizationId: item.organizationId,
            name: item.name
          }
        }
        return item
      })
    } else {
      obs[`${form.title}_${form.type}`] = val
    }
  }
  return obs
}

// 定义日期格式的正则表达式 (YYYY-MM-DD)
// 这个正则可以匹配您的 "2025-12-05" 这种格式
const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

/**
 * 辅助函数：检查一个对象的所有键是否都是日期字符串格式。
 * @param {Object} result 要检查的对象
 * @returns {boolean} 如果所有键都是日期格式则返回 true
 */
const areAllKeysDates = (result) => {
  if (Object.keys(result).length === 0) {
    return false; // 空对象不需要排序
  }
  return Object.keys(result).every(key => DATE_REGEX.test(key));
};

/**
 * 使用 Map 绝对保证属性的插入顺序，并保留“首次出现优先”原则
 * @param {Array<Object>} li 学生对象数组
 * @param {string} key 要访问的子对象的键名
 * @returns {Object} 合并后的结果对象，属性顺序绝对保证
 */
export const getResValue = (li, key) => {
  // 1. 使用 Map 严格按首次出现的顺序合并数据
  const resultMap = new Map();

  li.forEach(student => {
    const obj = student[key];

    // 健壮性检查：确保是普通对象
    if (obj && typeof obj === 'object' && !Array.isArray(obj)) {

      for (const k in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, k)) {
          // “首次出现优先”原则：Map 中没有才添加
          if (!resultMap.has(k)) {
            resultMap.set(k, obj[k]);
          }
        }
      }
    }
  });

  // 2. 将 Map 转换为普通对象，用于检查和排序
  let result = Object.fromEntries(resultMap);

  // 3. **条件判断和排序逻辑**
  if (areAllKeysDates(result)) {
    // 提取键名并排序（日期格式 YYYY-MM-DD 可以直接字符串升序排序）
    const sortedKeys = Object.keys(result).sort();

    // 重新构建一个有序的 Map 来保证返回结果的顺序（在现代 JS 引擎中 Object.fromEntries 即可）
    const sortedResult = {};

    sortedKeys.forEach(k => {
      sortedResult[k] = result[k];
    });

    return sortedResult;
  }

  // 4. 如果键不是日期格式，返回按插入顺序构建的结果
  return result;
};

export function extractChinese(str) {
  // 匹配更广泛的中文字符，包括中文标点符号
  return str.match(/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]+/g).join('') || '';
}

export function sortObjectsByField(arr, field, specialValues = []) {
  const specialSet = new Set(specialValues);

  return [...arr].sort((a, b) => {
    const aVal = String(a[field] || '');
    const bVal = String(b[field] || '');

    // 特殊值排最后
    if (specialSet.has(aVal) && specialSet.has(bVal)) return 0;
    if (specialSet.has(aVal)) return 1;
    if (specialSet.has(bVal)) return -1;

    // 正则分析
    const regex = /^([^\d]*)(\d+)?$/;
    const matchA = aVal.match(regex);
    const matchB = bVal.match(regex);

    if (!matchA || !matchB) {
      return aVal.localeCompare(bVal, 'zh-CN', {
        sensitivity: 'base',
        numeric: true
      });
    }

    const textA = matchA[1] || '';
    const textB = matchB[1] || '';
    const numA = matchA[2] ? parseInt(matchA[2], 10) : 0;
    const numB = matchB[2] ? parseInt(matchB[2], 10) : 0;

    // 文本比较
    const textCompare = textA.localeCompare(textB, 'zh-CN', {
      sensitivity: 'base'
    });
    if (textCompare !== 0) return textCompare;

    // 数字倒序
    return numB - numA;
  });
}


export const getDataSyncConfig = (dataSyncConfig, appinfo) => {
  const param = {
    tabletype: dataSyncConfig.selectType === 'app' ? 1 : 0,
    number: dataSyncConfig.maxSyncNum,
  }
  let datatype = 0
  let appid = 1
  const importConfig = {}
  if (dataSyncConfig.selectType === 'app' && dataSyncConfig.source.appId) {
    appid = dataSyncConfig.source.appId
  }
  if (dataSyncConfig.selectType === 'app' && dataSyncConfig.source.datatype) {
    datatype = dataSyncConfig.source.datatype
  }
  importConfig.import = dataSyncConfig.imports
  importConfig.isarchive = dataSyncConfig.isarchive
  importConfig.fields = dataSyncConfig.fields
  importConfig.where = dataSyncConfig.where
  importConfig.appid = appinfo.id || appinfo.approvalId
  param.importConfig = importConfig
  param.datatype = datatype
  param.appid = appid
  return param
}
